import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/buyer-panel/')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true })
  },
})
